import { useState } from "react";
export default function ProductCategoriesRow1() {
  const cards = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Wolfram-Services.jpg",
    alt: "Wolfram Services",
    labelLine1: "YOUR TECHNICAL SOURCING",
    labelLine2: "SPECIALISTS",
    labelBg: "#5a5e14",
    href: "#"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Underground-Mining.jpg",
    alt: "Underground Mining Equipment",
    labelLine1: "UNDERGROUND MINING EQUIPMENT",
    labelLine2: "",
    labelBg: "#8b1a1a",
    href: "#"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Untitled-design-3.jpg",
    alt: "Wolfram Mining Supplies | Mining Equipment South Africa",
    labelLine1: "FLEXIGLOW",
    labelLine2: "LED STRIP LIGHTS",
    labelBg: "#3a6b8a",
    href: "#"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Hella_9bc1e2e09d.jpg",
    alt: "Hella Automotive & Lighting",
    labelLine1: "HELLA LIGHTING & AUTOMOTIVE",
    labelLine2: "SOLUTIONS",
    labelBg: "#3a6b8a",
    href: "#"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Picture12.jpg",
    alt: "High Density Solids, Concrete & Mortar Pumps",
    labelLine1: "HIGH DENSITY SOLIDS, CONCRETE & MORTAR",
    labelLine2: "PUMPS",
    labelBg: "#5a5e14",
    href: "#"
  }];
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  return;
}